<form #form (ngSubmit)="doSubmit($event)">
  <ng-content></ng-content>
</form>
